import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { GrupoClassificacaoConfigMultiselectComponent } from './grupo-classificacao-config-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        GrupoClassificacaoConfigMultiselectComponent
    ],
    exports: [
        GrupoClassificacaoConfigMultiselectComponent
    ]
})
export class GrupoClassificacaoConfigMultiselectModule { }
